module.exports = require("react/lib/ReactCSSTransitionGroup");
